angular
    .module("home.controller")
    .controller('forgotPasswordController', ['$rootScope', '$scope', '$location', '$window', 'userService',
        function ($rootScope, $scope, $location, $window, userService) {
            $scope.forgotPassword = true;
            $scope.submitted = false;
            $scope.submitSuccessful = false;

            $scope.isPopup = function () {
                return $location.path().indexOf('forgot-password') === -1;
            };

            // $scope.emailPattern = "^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$";

            $scope.emailInvalid = false;
            $scope.ngFocus = function (element) {
                $('#' + element).focus();
            }
            $scope.resetPasswordModel = {
                identifier: '',
                email: '',
                // captcha model
                captchaString: '',
                captchaStringEncrypt: '',
                captchaToken:''
            };

            $scope.isFocusEmail = false;
            $scope.isFocusCaptcha = false;

            $scope.base64String = '';

            $scope.captchaStringHasValue = true;

            $scope.captchaChange = function () {
                $scope.captchaStringHasValue = true;
            };

            $scope.isCaptchaStringCorrected = false;


            // Renew captcha image for the first time
            recreateCaptchaImage();

            // Refresh captcha image
            $scope.recreateCaptchaImage = function () {
                // not validate if click on refresh captcha image button
                recreateCaptchaImage();
                $scope.submitted = false;
                $scope.captchaStringHasValue = true;                
            };
            // Recreate captcha image function
            function recreateCaptchaImage() {
                userService.requestCaptchaImage().then(function (response) {
                    $scope.resetPasswordModel.captchaString = '';
                    $scope.resetPasswordModel.captchaStringEncrypt = response.CaptchaStringEncrypt;
                    $scope.base64String = response.Base64String;
                    $scope.resetPasswordModel.captchaToken = response.Token;
                    $scope.isFocusCaptcha = false;
                });
            }

            //ChangePasswordFeature
            $scope.userRequestResetPassword = function (resetPasswordModel) {
                $scope.submitted = true;
                $scope.emailInvalid = false;
                $scope.submitSuccessful = false;

                var thisForm = this.resetPasswordForm;
                if (!thisForm.$valid) {
                    // autofocus input
                    // $scope.isFocusCaptcha = true;
                    return;
                }

                userService.requestResetPassword(resetPasswordModel).then(function (response)
                {
                    if (response.ErrorMessage === 'Invalid captcha.') {
                        $scope.captchaStringHasValue = false;
                        $scope.submitSuccessful = false;
                        recreateCaptchaImage();
                        
                    } else if (response.ErrorMessage === 'Email address does not exist.') {
                        // thisForm.email.$setValidity('email', false);
                        $scope.emailError = response.ErrorMessage;
                        $scope.emailInvalid = true;
                        $scope.submitSuccessful = false;
                        recreateCaptchaImage();
                    } else if (response.Success === true) {
                        $scope.isCaptchaStringCorrected = true
                        $scope.submitSuccessful = true;

                    }
                });
            };

            $scope.closeAll = function () {
                $rootScope.closePopups();
                if (!$scope.isPopup()) {
                    //Redirect user to homepage
                    $window.location = "/";
                }
            };

            $scope.forcusEmail = function() {
                $scope.isFocusEmail = true; 
                $scope.emailInvalid = false;
            }

           
        }]);